'use client';

import styles from './ImageModal.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const ImageModal = ({
  className,
  children,
  ctaText,
  ctaOnClick,
}: {
  className?: string;
  children?: React.ReactNode | undefined;
  ctaText?: string;
  ctaOnClick?: () => void;
}) => {
  return (
    <div
      className={cx(styles.root, className)}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      <div className={styles.childrenContainer}>{children}</div>
      {ctaText && ctaText.length ? (
        <div className={styles.stickyContainer}>
          <button onClick={ctaOnClick}>{ctaText}</button>
        </div>
      ) : null}
    </div>
  );
};
